import {
  getWebsitesAction,
  getWebsitesSuccessAction,
  getWebsitesFailAction,
  upsertWebsiteAction,
  upsertWebsiteSuccessAction,
  upsertWebsiteFailAction,
  deleteWebsiteSuccessAction,
  deleteWebsiteFailAction,
  deleteWebsiteAction,
} from '../ecom.actions';
import { Website } from '../interfaces';
import { createReducer, Action, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export interface State extends EntityState<Website> {
  selectedWebsiteId: string;
  isLoading: boolean;
  isUpserting: boolean;
  isDeleting: boolean;
}

export function selectWebsiteId(a: Website): string {
  return a.websiteId;
}

export function sortByName(a: Website, b: Website): number {
  return a.accountId.localeCompare(b.accountId);
}

export const adapter: EntityAdapter<Website> = createEntityAdapter<Website>({
  selectId: selectWebsiteId,
  sortComparer: sortByName,
});

export const initialState: State = adapter.getInitialState({
  selectedWebsiteId: null,
  isLoading: false,
  isUpserting: false,
  isDeleting: false,
});

const websiteReducer = createReducer(
  initialState,
  on(getWebsitesAction, (state) => ({ ...state, isLoading: true })),
  on(getWebsitesSuccessAction, (state, action) => ({
    ...state,
    ...adapter.setAll(action.websites, state),
    isLoading: false,
  })),
  on(getWebsitesFailAction, (state) => ({ ...state, isLoading: false })),
  on(upsertWebsiteAction, (state) => ({ ...state, isUpserting: true })),
  on(upsertWebsiteSuccessAction, upsertWebsiteFailAction, (state) => ({
    ...state,
    isUpserting: false,
  })),
  on(deleteWebsiteAction, (state) => ({ ...state, isDeleting: true })),
  on(deleteWebsiteSuccessAction, deleteWebsiteFailAction, (state) => ({
    ...state,
    isDeleting: false,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return websiteReducer(state, action);
}

const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();

export const selectWebsiteIds = selectIds;
export const selectWebsiteEntities = selectEntities;
export const selectAllWebsites = selectAll;
export const selectWebsiteTotal = selectTotal;
export const getSelectedWebsiteId = (state: State) => state.selectedWebsiteId;
